export const RULE_GROUP_DELIMITER = "@"
export const RULE_DELIMITER = "#"